export const RESET_FILTERS_BUTTON_LABEL = "Clear all filters";
